import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoData } from '../interfaces/seo.interface';


@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) private document: Document
  ) {}

  updateSeoTags(data: SeoData): void {

    // Page Title
    this.titleService.setTitle(data.title);

    // Description
    this.metaService.updateTag({
      name: 'description',
      content: data.description
    });

    // Keywords
    if (data.keywords) {
      this.metaService.updateTag({
        name: 'keywords',
        content: data.keywords
      });
    }

    // Robots
    if (data.robots) {
      this.metaService.updateTag({
        name: 'robots',
        content: data.robots
      });
    }

    // Open Graph Title
    if (data.ogTitle) {
      this.metaService.updateTag({
        property: 'og:title',
        content: data.ogTitle
      });
    }

    // Open Graph Description
    if (data.ogDescription) {
      this.metaService.updateTag({
        property: 'og:description',
        content: data.ogDescription
      });
    }

    // Open Graph Image
    if (data.ogImage) {
      this.metaService.updateTag({
        property: 'og:image',
        content: data.ogImage
      });
    }

    // Canonical URL
    if (data.canonicalUrl) {
      this.setCanonicalUrl(data.canonicalUrl);
    }
  }

  private setCanonicalUrl(url: string): void {

    let link: HTMLLinkElement | null =
      this.document.querySelector("link[rel='canonical']");

    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }

    link.setAttribute('href', url);
  }
}